import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SettingsSharp as SettingsIcon } from '@material-ui/icons';
import { ProjectTeamMemberAssignmentType } from '~/types';
import EditProjectDialog from '../EditProjectDialog';
import EditProjectSettingsForm from './EditProjectSettingsForm';
import { useUpdateProjectSettings } from './useUpdateProjectSettings';

const projectSettingsTitle = (
  <FormattedMessage id="projectSettingsCard.projectSettings" />
);

export const EditProjectSettingsDialog = ({
  open,
  onClose,
  projectId,
  projectTeamMemberAssignmentType
}) => {
  const initialValues = useMemo(
    () => ({
      projectUri: projectId,
      projectTeamMemberAssignmentType:
        projectTeamMemberAssignmentType ||
        ProjectTeamMemberAssignmentType.ManuallyAssignTask
    }),
    [projectId, projectTeamMemberAssignmentType]
  );

  const onSubmit = useUpdateProjectSettings({ closeDialog: onClose });

  return (
    <EditProjectDialog
      title={projectSettingsTitle}
      open={open}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      icon={SettingsIcon}
      maxWidth="sm"
    >
      <EditProjectSettingsForm />
    </EditProjectDialog>
  );
};

EditProjectSettingsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  projectId: PropTypes.string,
  projectTeamMemberAssignmentType: PropTypes.string
};

export default EditProjectSettingsDialog;
